<template>
  <div class="superuser-search-result-product superuser-search-result--product-result">
    <div v-if="mq('medium')" class="superuser-search-result-product__head">
      <div class="superuser-search-result-product__cell">
        {{ tStatic('superUserSearchResultProductReferenceItemNo') }}
      </div>

      <div class="superuser-search-result-product__cell">
        {{ tStatic('superUserSearchResultProductReferenceRefNo') }}
      </div>

      <div class="superuser-search-result-product__cell">
        {{ tStatic('superUserSearchResultProductReferenceCompany') }}
      </div>

      <div class="superuser-search-result-product__cell">
        {{ tStatic('superUserSearchResultProductReferenceType') }}
      </div>

      <div class="superuser-search-result-product__cell">
        {{ tStatic('superUserSearchResultProductReferenceStatus') }}
      </div>
    </div>

    <template v-if="rows === null">
      <div class="superuser-search-result__body-row superuser-search-result__body-row--message">
        {{ t('superuserSearchDoSearchPhrase') }}
      </div>
    </template>

    <template v-else-if="rows && rows.length === 0">
      <div class="superuser-search-result__body-row superuser-search-result__body-row--message">
        {{ t('superuserSearchNoHits') }}
      </div>
    </template>

    <template v-else>
      <div
        v-for="row in rows"
        :key="row.itemNo + '_' + row.refNo"
        class="superuser-search-result__body-row">
        <div class="superuser-search-result-product__cell">
          <div v-if="mq('to-medium')">
            {{ tStatic('superUserSearchResultProductReferenceItemNo') }}
          </div>

          {{ row.itemNo }}
        </div>

        <div class="superuser-search-result-product__cell">
          <div v-if="mq('to-medium')">
            {{ tStatic('superUserSearchResultProductReferenceRefNo') }}
          </div>

          {{ row.refNo }}
        </div>

        <div class="superuser-search-result-product__cell">
          <div v-if="mq('to-medium')">
            {{ tStatic('superUserSearchResultProductReferenceCompany') }}
          </div>

          {{ row.company }}
        </div>

        <div class="superuser-search-result-product__cell">
          <div v-if="mq('to-medium')">
            {{ tStatic('superUserSearchResultProductReferenceType') }}
          </div>

          {{ row.type }}
        </div>

        <div class="superuser-search-result-product__cell">
          <div v-if="mq('to-medium')">
            {{ tStatic('superUserSearchResultProductReferenceStatus') }}
          </div>

          {{ row.status }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    rows: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    userIsSyncing: false
  }),
  methods: {
  }
}
</script>

<style lang="scss">
.superuser-search-result-product {
  @include body-smaller;
  background-color: color(background-white);
  border: 1px solid color(border-gray);
}

.superuser-search-result-product > div:not(:last-child) {
  border-bottom: 1px solid color(border-gray);
}

.superuser-search-result-product__head {
  display: flex;
  background-color: color(background-blue-6);
  padding-right: measure(quarter);
  padding-left: measure(quarter);
}

.superuser-search-result__body-row {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  flex-wrap: wrap;
  padding-right: measure(quarter);
  padding-left: measure(quarter);

  @include media(small) {
    flex-direction: row;
  }

  @include media(medium) {
    flex-wrap: nowrap;
  }
}

.superuser-search-result__body-row_removed {
  text-decoration: line-through;
}

.superuser-search-result__body-row--message {
  justify-content: center;
  min-height: 3rem;
  padding: measure(quarter);
  font-style: italic;
}

.superuser-search-result-product__cell {
  flex-shrink: 0;
  padding: measure(quarter);

  @include media(to-small) {
    width: 100%;
  }

  &:nth-child(1) {
    @include media(small) {
      width: 50%;
    }

    @include media(medium) {
      width: 7%;
    }
  }

  &:nth-child(2) {
    @include media(small) {
      width: 50%;
    }

    @include media(medium) {
      width: 23%;
      word-break: break-all;
    }
  }

  &:nth-child(3) {
    @include media(small) {
      width: 50%;
    }

    @include media(medium) {
      width: 23%;
    }
  }

  &:nth-child(4) {
    @include media(small) {
      width: 50%;
    }

    @include media(medium) {
      width: auto;
      flex-grow: 1;
    }
  }
}

.superuser-search-result-product__head > .superuser-search-result-product__cell,
.superuser-search-result-product__cell > div:first-child {
  @include body-smaller-semi-bold;
}

.superuser-search-result-product__cell-bolder {
  @include body-smaller;

  @include media(medium) {
    @include body-smaller-semi-bold;
  }
}

.superuser-search-result-product__cell--actions {
  display: flex;
  flex-direction: column;

  @include media(small) {
    flex-direction: row;
    align-self: center;
  }
}

</style>
